import { getPackDisplayString } from '@/utils/item';
import { OrderGuideItem } from '@/experiences/sales-portal/domain/order-guides/blocs/types';
import { PackUnit } from '@/enums';

// Fields shared by the OG-items and catalog-search responses (both
// `SalesPortalOrderGuideItem`).
export interface OrderGuideItemSource {
  entry_info?: { par_level?: number | null } | null;
  item_info: { image_url?: string | null; item_id: string; name: string };
  pack_info: {
    external_item_id?: string | null;
    max_unit_size: number;
    min_unit_size: number;
    unit: string;
  };
  variant_pack_id: string;
}

export const toOrderGuideItem = ({
  entry_info: entryInfo,
  item_info: itemInfo,
  pack_info: packInfo,
  variant_pack_id,
}: OrderGuideItemSource): OrderGuideItem => ({
  displayName: itemInfo.name,
  externalID: packInfo.external_item_id ?? null,
  imageURL: itemInfo.image_url ?? null,
  itemUUID: itemInfo.item_id,
  packDisplayString: getPackDisplayString({
    abbreviated: true,
    maxUnitSize: packInfo.max_unit_size,
    minUnitSize: packInfo.min_unit_size,
    unit: packInfo.unit as PackUnit,
  }),
  parLevel: entryInfo?.par_level ?? null,
  variantPackUUID: variant_pack_id,
});
